export const CONNECTION_CONFIG = 'CONNECTION_CONFIG'
export const SET_USER = 'SET_USER'
export const SET_USER_AVATAR = 'SET_USER_AVATAR'
export const SET_VEHICLE = 'SET_VEHICLE'
export const SET_VIDEO = 'SET_VIDEO'
export const VIDEO_TIME_UPDATE = 'VIDEO_TIME_UPDATE'
export const VIDEO_SEEK_TO = 'VIDEO_SEEK_TO'
export const SET_TRACK = 'SET_TRACK'
export const SET_TRACK_POINTS = 'SET_TRACK_POINTS'
export const SET_TRACK_CURRENT_IDX = 'SET_TRACK_CURRENT_IDX'
export const SET_TRACK_DISTANCES = 'SET_TRACK_DISTANCES'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js